import { getUserListItemContentAdditionalText } from '../../../utils/user'
import { getUserMultiValueName, toUserMultiValue } from '../UserMultiValue'

import { USER_AVATAR_GROUP_MORE_TOOLTIP_SEPARATOR } from './UserAvatarGroup.constants'

function toUserAvatarGroupItem(user) {
  return toUserMultiValue(user).user
}

export function toUserAvatarGroupItems(users) {
  return users.map(toUserAvatarGroupItem)
}

export function getUserAvatarGroupItemTooltip({ item, t }) {
  return `${getUserMultiValueName({ t, user: item })}${getUserListItemContentAdditionalText(
    {
      companyPostName: item.companyPostName,
      role: item.role,
    }
  )}`
}

export function getUserAvatarGroupMoreTooltip({ items, t }) {
  return items
    .map(item => getUserAvatarGroupItemTooltip({ item, t }))
    .join(USER_AVATAR_GROUP_MORE_TOOLTIP_SEPARATOR)
}
